import { useEffect, useState } from 'react';
import Slider from 'react-slick';
import './products.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Title from '../shared/Title';
// import Description from '../shared/Description';
import Popup from 'reactjs-popup';
import SlickArrow from '../shared/SlickArrow';
import CustomPaging from '../shared/CustomPaging';
import { apispreadsheets, imgFromDriveUrl } from '../shared/ApiSpreadSheets';
import { Markup } from 'interweave';

function Products() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [sheet, setSheet] = useState([]);
  const [sheetDetail, setSheetDetail] = useState([]);
  const [productsImage, setProductsImage] = useState([]);
  const [description, setDescription] = useState([])
  const [productDetail, setProductDetail] = useState([]);
  const [productLink, setProductLink] = useState([]);

  const [activeGroup, setActiveGroup] = useState(0);
  const [selectedImage, setSelectedImage] = useState(0);
  //popup open state
  const [open, setOpen] = useState(false);
  const closeModal = () => {
    setTimeout(() => setOpen(false), 200);
  };

  // FETCH DATA AND SET STATUS
  useEffect(() => {
    const sheetName = 'san_pham_noi_bat_cua_sinh_vien';
    const sheetDetail = 'thong_tin_san_pham';

    const loadData = async () => {
      try {
        const response1 = await fetch(`${apispreadsheets}/${sheetName}`);
        const results1 = await response1.json();

        const imgArray = results1[0]?.hinh_anh ? results1[0].hinh_anh.split('\n') : [];
        const linkArray = results1[3]?.link_youtube.split('\n');

        setProductsImage(imgArray);
        setProductLink(linkArray);
        setDescription(results1[0]?.mo_ta || '');
        setSheet(results1);

        const response2 = await fetch(`${apispreadsheets}/${sheetDetail}`);
        const results2 = await response2.json();

        const info = results2[0]?.san_pham ? results2[0].san_pham.split('\n') : [];
        setProductDetail(info);
        setSheetDetail(results2);

        setIsLoaded(true);
      } catch (error) {
        console.log('error: ', error);
        setIsLoaded(false);
      }
    };

    loadData();
  }, [setSheetDetail]);
  //selected index by group
  const handleActiveGroup = (index) => {
    setActiveGroup(index);
    const imgArray = sheet[index].hinh_anh.split('\n');
    setProductsImage(imgArray);

    // Kiểm tra nếu có dữ liệu sản phẩm
    const info = sheetDetail[index].san_pham.split('\n');
    setProductDetail(info);
  };
  //selected iamge
  // const handselectedImage = (index) => {
  //   setSelectedImage(index);

  // };
  // format product info
  const formatProductInfo = (index) => {
    const info = productDetail[index].split(';');
    return (
      <ul className='pl-3 pt-5'>
        {info.map((val, idx) => (
          <li className='text-[#fdf34e] text-left md:text-base' key={idx}>{val}</li>
        ))}
      </ul>
    )
  }

  const sytle = {
    maxWidth: '1024px',
    width: '90vw',
  };
  const settingsTab = {
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    centerPadding: 0,
    arrows: true,
    swipeToSlide: true,
    initialSlide: 0,
    afterChange: (current) => handleActiveGroup(current),
    nextArrow: <SlickArrow classname={`product-arrow`} right="0" />,
    prevArrow: <SlickArrow classname={`product-arrow`} left="0" />,
  };
  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 3,
    arrows: false,
    speed: 500,
    rows: 2,
    lazyLoad: "ondemand",
    initialSlide: 0,
    customPaging: () => <CustomPaging className="mt-10 pl-[2.5%] md:ol-[4%]" />,
    responsive: [
      {
        breakpoint: 845,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          rows: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
        },
      },
    ],
  };

  if (!isLoaded) {
    return <div>Loading...</div>;
  } else {
    return (
      <div id="products px-5 xl:px-36">
        <div className="text-center ">
          <Title className="text-primary-color my-8 sm:text-3xl font-bold uppercase">
            sản phẩm nổi bật của sinh viên
          </Title>
          <div className="mt-5 text-justify md:text-center font-medium">
            <Markup
              allowAttributes
              content={description}
            />
          </div>

        </div>
        <div className="products-tab md:mx-[50px] mx-4">
          {/* Header */}
          {/*  */}
          <div className="process-bar relative h-[50px] mt-[65px] w-full ">
            <ul className="w-full absolute justify-between content-center list-none mt-[-40px] z-[1] pt-[15px] flex-wrap rounded-[15px] hidden md:flex">
              {sheet.map((product, index) => (
                <li
                  key={'tab ' + index}
                  className={`tag-header-item w-[20%] relative flex-auto md:m-0 ${index === activeGroup ? 'active' : ''
                    }`}
                  onClick={() => {
                    index !== activeGroup && handleActiveGroup(index);
                  }}
                >
                  <div
                    className={`b-red flex justify-center group-name uppercase text-center font-bold cursor-pointer md:h-[60px] md:text-base p-2.5 h-full w-full`}
                  >
                    {product.tieu_de}
                  </div>
                </li>
              ))}
            </ul>
            {/* header moblie */}
            <div className="md:hidden swipe-tab">
              <Slider {...settingsTab}>
                {sheet.map((product, index) => (
                  <div key={'tab ' + index}>
                    <div
                      className={`b-red flex justify-center items-center group-name uppercase text-center text-base font-bold cursor-pointer md:h-[60px] md:xl p-2.5 h-full w-full 
                      ${index === activeGroup ? 'border-primary-color border-b-2 border-t-2' : ''}`}
                      onClick={() => {
                        index !== activeGroup && handleActiveGroup(index);
                      }}
                    >
                      {product.tieu_de}
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
            {/* horizontal line*/}
            <div>
              <div className="process-bar-line w-full m-auto bg-primary-color h-1 absolute md:top-[68px] top-[48px] md:block hidden"></div>
            </div>
          </div>
          {/* Content */}
          <div className="tab-content w-full mt-8 md:mt-20">
            <div className="tab-content-item">
              <Slider {...settings}>
                {/* start slide image */}
                {productsImage.map((image, index) => (
                  <div key={index}>
                    {activeGroup === 3 && productLink[index] ? (
                      // Nếu có link YouTube, bọc ảnh trong thẻ <a> để mở video
                      <a href={productLink[index]} target="_blank" rel="noopener noreferrer">
                        <div className="box rounded-[20px] mx-[20px] my-[15px] overflow-hidden relative xl:h-[250px] lg:h-[200px] h-full shadow-[0_0_10px_0px_#adb5bd]">
                          <img
                            className="product-slide-img rounded-[20px] bg-[#fdf34e] w-full h-full align-middle object-cover"
                            src={`${imgFromDriveUrl(image)}`}
                            alt={'image-' + index}
                            loading="lazy"
                          />
                        </div>
                      </a>
                    ) : (
                      // Nếu không có link YouTube, chỉ hiển thị ảnh bình thường
                      <div
                        className="box rounded-[20px] mx-[20px] my-[15px] overflow-hidden relative xl:h-[250px] lg:h-[200px] h-full shadow-[0_0_10px_0px_#adb5bd]"
                        onMouseDown={() => setSelectedImage(index)}
                        onMouseMove={() => {
                          setOpen(false);
                          setSelectedImage(-1);
                        }}
                        onMouseUp={() => {
                          setOpen(!open && selectedImage !== -1);
                        }}
                      >
                        <img
                          className="product-slide-img rounded-[20px] bg-[#fdf34e] w-full h-full align-middle object-cover"
                          src={`${imgFromDriveUrl(image)}`}
                          alt={'image-' + index}
                          loading="lazy"
                        />
                        <div className="product-overlay w-full h-full top-1/2 left-1/2 absolute translate-x-[-50%] translate-y-[-50%] rounded-[20px]">
                          {formatProductInfo(index)}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
                {/* end slide image */}
              </Slider>
              {open && (
                <Popup open={true} closeOnDocumentClick onClose={closeModal} contentStyle={sytle} modal>
                  <div className="bg-white h-full relative shadow-2xl rounded-[25px]">
                    <div className="flex justify-end pr-3.5 pb-2.5 bg-[0_0_0_0.5] rounded-tr-[25px] rounded-tl-[25px]">
                      <span
                        className="close text-4xl hover:scale-[1.1] cursor-pointer text-red-600 float-right font-bold right-0 mx-2 mt-2"
                        onClick={() => setOpen(false)}
                      >
                        &times;
                      </span>
                    </div>
                    <img
                      className="rounded-br-[25px] rounded-bl-[25px] bg-[#fdf34e] w-full h-full align-middle object-cover"
                      src={`${imgFromDriveUrl(productsImage[selectedImage])}`}
                      alt={`products-img`}
                    />

                  </div>
                </Popup>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Products;
